<template>
  <div>
    <Header :title="$t('loanpage.title')" />
    <div class="full-page-box">
      <div class="txt-box">
        <p>1. Điều kiện vay là gì ?</p>
        <p>
          - Có quốc tịch Việt Nam và trong độ tuổi từ 18-65 tuổi, có địa chỉ
          thường trú và địa chỉ làm việc hiện tại trong lãnh thổ Việt Nam, có
          CMND/CCCD còn hiệu lực, có thu nhập ổn định. Có các giấy tờ như bảo
          hiểm xã hội hoặc bảo hiểm y tế, hợp đồng lao động ...
        </p>
        <p>2. Làm sao để đăng ký vay ?</p>
        <p>- Bạn có thể tải ứng dụng và đăng ký vay ngay trên ứng dụng</p>
        <p>
          3. Khi thẩm định hồ sơ ngân hàng có tiến hành thông báo và kiểm tra
          thông tin qua người thân như vợ hoặc chồng, bạn bè của người vay không
          ?
        </p>
        <p>- KHÔNG</p>
        <p>
          * Liên hệ người thân chỉ dùng trong trường hợp vay thành công nhưng
          tới kì hạn đóng tiền người vay không thực hiện nghĩa vụ trả nợ và
          không thể liên lạc được. Lúc đó phía ngân hàng sẽ liên lạc với các
          liên hệ này để nhắc nhở và thông báo
        </p>
      </div>
      <div style="width: 90%;margin: 30px auto 0;">
        <van-button class="btn" @click="toHome">{{ $t('loanpage.btn') }}</van-button>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer/index.vue";
import Header from "@/components/header/index.vue";
export default {
  name: "LoanPage",
  components: { Footer, Header },
  methods:{
    toHome(){
        this.$router.push({ name: 'home' });
    }
  },
  created(){
    if(!localStorage.getItem('token')){
      this.$router.push({ name: 'login' });
    }
  },
};
</script>
<style scoped>
.txt-box {
  width: 96%;
  margin: 10px auto;
  font-size: 16px;
  line-height: 1.4;
}
.btn{
    background-color: rgb(4, 109, 181);
    border-radius: 8px;
    color:#fff;
    width: 100%;
}
</style>
